$.fn.dataSetDefault = function (key, value) {
    return this.each(function () {
        let $this = $(this);
        if ($this.data(key) === undefined) {
            $this.data(key, value);
        }
    });
};
